module.exports = __webpack_public_path__ + "static/media/el_woman.281effd5.png";